import { connect } from 'react-redux';
import './section.css';
import React, { Fragment } from 'react';
import { CompositeDecorator } from 'draft-js';
import _ from 'lodash';

import { setEditorFieldValue, setFunctionValue } from './setEditorFieldValue';

function findWithRegex(regex, contentBlock, callback) {
  const text = contentBlock.getText();
  let matchArr = regex.exec(text),
    start;
  while (matchArr !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
    matchArr = regex.exec(text);
  }
}

const TEMPLATE_REGEX = /\$\{[a-zA-Z0-9]+\}/g;

function variablesStrategy(contentBlock, callback) {
  findWithRegex(TEMPLATE_REGEX, contentBlock, callback);
}

const mapStateToProps = (
  { formalNotice, courtApplication },
  { decoratedText, children }
) => {
  const taskName = formalNotice.options ? formalNotice : courtApplication;
  const { fullPaxFieldsData, options } = taskName;
  const language = options.languageOption || 'fr';
  const paxDataKey = decoratedText.substring(2, decoratedText.length - 1);
  let { type, value, name } = _.find(fullPaxFieldsData, ['id', paxDataKey]);

  switch (type) {
    case 'textarea':
      value = value.split('\n');
      break;
    case 'function':
      value = setFunctionValue(value, fullPaxFieldsData);
      break;
    default:
      value = setEditorFieldValue(type, value, language);
  }

  return {
    children: value || name || children,
    hasValue: value
  };
};

const TemplateField = connect(mapStateToProps)(({ children, ...rest }) => {
  return typeof children === 'object' ? (
    children.map(element => (
      <Fragment key={element}>
        <TemplateSpan children={element} {...rest} />
        <br />
      </Fragment>
    ))
  ) : (
    <TemplateSpan children={children} {...rest} />
  );
});

const TemplateSpan = ({ children, className, hasValue }) => {
  return (
    <span
      contentEditable={false}
      readOnly
      className={[
        'section-variables-decorator',
        !hasValue && 'empty-field',
        className
      ].join(' ')}
    >
      {children}
    </span>
  );
};

const compositeDecorator = new CompositeDecorator([
  {
    strategy: variablesStrategy,
    component: TemplateField
  }
]);

export default compositeDecorator;



// WEBPACK FOOTER //
// ./src/component/TaskCreator/Section/Decorator.js